import React, { useCallback, useContext, useState } from 'react';
import { CreationInvestorContext } from '../CreationInvestorContext';
import ManageAuthorizations from '../../../users/userauthorization/stepper/ManageAuthorizations';
import { isEqual } from 'lodash';
import { ContactsTable } from '../../../funds/creationSteps/AddRelatedContacts/ContactsList';

const ContactsList = ({
  contacts,
  classes,
  groups,
  authorizationsConnectedUser,
  connectedUserProfile,
  permissionGroupsUploaded,
  setCurrentAuthorizations,
  currentAuthorizations,
  onSubmitEnd,
  hasAssignUserAuthorization,
  relatedFundsUploaded,
  setIsNextAvailable,
  setPermissionGroupsUploaded,
  authorizationsGridToDeleteRef,
  permissionToDelete,
  setPermissionToDelete,
  originalPermissions,
  ...props
}) => {
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const { investorContext: context } = useContext(CreationInvestorContext);

  const displayTooltip = useCallback(
    contactId => {
      const currentUserAuthorization = currentAuthorizations.filter(
        authorization => authorization.userId === contactId
      );
      const currentUserAuthorizationToDelete = permissionToDelete.filter(
        authorization => authorization.userId === contactId
      );
      const currentUserPermissionUploaded = originalPermissions.filter(
        authorization => authorization.userId === contactId
      );

      if (
        currentUserAuthorization.length > 0 &&
        currentUserAuthorizationToDelete.length > 0
      ) {
        return !isEqual(
          currentUserAuthorization,
          currentUserAuthorizationToDelete
        );
      }

      if (
        currentUserAuthorization.length > 0 &&
        currentUserPermissionUploaded.length > 0
      ) {
        return !isEqual(
          currentUserAuthorization,
          currentUserPermissionUploaded
        );
      }

      if (
        currentUserAuthorization.length > 0 &&
        currentUserAuthorizationToDelete.length === 0
      ) {
        return true;
      }

      if (
        currentUserAuthorization.length === 0 &&
        currentUserAuthorizationToDelete.length > 0
      ) {
        return true;
      }
    },
    [currentAuthorizations, originalPermissions, permissionToDelete]
  );

  const handleManageClick = contact => {
    setSelectedContact(contact);
    setIsManageModalOpen(true);
  };
  return (
    <>
      <ContactsTable
        contacts={contacts}
        classes={classes}
        displayTooltip={displayTooltip}
        handleManageClick={handleManageClick}
      />
      {selectedContact && (
        <ManageAuthorizations
          contact={selectedContact}
          isManageModalOpen={isManageModalOpen}
          setIsManageModalOpen={setIsManageModalOpen}
          groups={groups}
          connectedUserProfile={connectedUserProfile}
          authorizationsConnectedUser={authorizationsConnectedUser}
          permissionGroupsUploaded={permissionGroupsUploaded}
          setCurrentAuthorizations={setCurrentAuthorizations}
          currentAuthorizations={currentAuthorizations}
          onSubmitEnd={onSubmitEnd}
          hasAssignUserAuthorization={hasAssignUserAuthorization}
          relatedFundsUploaded={relatedFundsUploaded}
          setIsNextAvailable={setIsNextAvailable}
          context={context}
          setPermissionGroupsUploaded={setPermissionGroupsUploaded}
          authorizationsGridToDeleteRef={authorizationsGridToDeleteRef}
          permissionToDelete={permissionToDelete}
          setPermissionToDelete={setPermissionToDelete}
          {...props}
        />
      )}
    </>
  );
};

export default ContactsList;
